import script from "./Verify2FA.vue?vue&type=script&setup=true&lang=js"
export * from "./Verify2FA.vue?vue&type=script&setup=true&lang=js"

import "./Verify2FA.vue?vue&type=style&index=0&id=037db806&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037db806"]])

export default __exports__